import type { FindOperationsInput } from '@travel-planner/shared/schemas/operations';
import { trpc } from '@/shared/api/trpc';

export const useFailedMessagesData = (
  input: FindOperationsInput,
  options?: { enabled?: boolean }
) =>
  trpc.operations.failedMessages.useQuery(input, {
    enabled: options?.enabled ?? true,
  });
